import { generateSpectrum } from 'spectrum-generator';
import { simulateXYPeaks } from './simulateXYPeaks';
/**
 * This function simulates a one dimensional nmr spectrum. This function returns an array containing the relative intensities of the spectrum in the specified simulation window (from-to).
 */
export default function simulate1D(
/**
 * The SpinSystem object to be simulated
 */
spinSystem, options = {}) {
    let { lineWidth = 1, frequency: frequencyMHz = 400, from = 0, to = 10, nbPoints = 1024, shape = {
        kind: 'gaussian',
    }, } = options;
    let peakWidth = lineWidth / frequencyMHz;
    const xyPeaks = simulateXYPeaks(spinSystem, options);
    return generateSpectrum(xyPeaks, {
        generator: {
            from,
            to,
            nbPoints,
        },
        peakOptions: {
            shape,
            width: peakWidth,
        },
    });
}
//# sourceMappingURL=simulate1D.js.map